import { handleApiResponse, apiReadWithAuth } from '../../fetchUtils';

export const BEGIN_MODULES_FETCH = 'BEGIN_MODULES_FETCH'
export const MODULES_FETCH_SUCCESS = 'MODULES_FETCH_SUCCESS'
export const MODULES_FETCH_FAILURE = 'MODULES_FETCH_FAILURE'

function beginModulesFetch() {
  return { type: BEGIN_MODULES_FETCH }
}

function modulesFetchSuccess() {
  return { type: MODULES_FETCH_SUCCESS }
}

function modulesFetchFailure(errorMessage) {
  return { type: MODULES_FETCH_FAILURE, errorMessage }
}

export function fetchModules(dispatch, path) {
  dispatch(beginModulesFetch())
  const callbacks = {
    onSuccess:  ()=>dispatch(modulesFetchSuccess()),
    onError:    error=>dispatch(modulesFetchFailure(error.message))
  }
  dispatch(apiReadWithAuth(path, callbacks))
}
